<template>
  <div>
    <b-card>
      <b-row align-v="center">
        <b-col>
          <h2 class="mb-0">Metas de Retenção</h2>
          <small class="text-muted">
            Faixas de meta (% de distribuidores retidos na região da analista) e o prêmio de cada uma, por mês.
            Aparecem aqui os usuários com "Região da retenção" no cadastro.
          </small>
        </b-col>
        <b-col cols="12" md="auto" class="mt-2 mt-md-0">
          <b-button variant="outline-secondary" size="sm" class="mr-3" href="/adm/retencao">
            <i class="fas fa-arrow-left"></i> Retenção
          </b-button>
          <label class="mb-0 mr-2">Mês</label>
          <b-form-input
            v-model="competencia"
            type="month"
            size="sm"
            class="d-inline-block"
            style="width: 170px"
            :disabled="loading || salvando"
            @change="carregar()"
          ></b-form-input>
        </b-col>
      </b-row>

      <div v-if="loading" class="text-center my-5">
        <b-spinner></b-spinner>
      </div>

      <div v-else-if="!analistas.length" class="text-center text-muted my-5">
        Nenhum usuário com região da retenção. Defina a região no cadastro de usuários.
      </div>

      <template v-else>
        <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
          <b-button
            variant="outline-primary"
            size="sm"
            :disabled="salvando || !temAnterior"
            @click="copiarAnterior()"
          >
            <i class="far fa-copy"></i> Copiar faixas de {{ nomeMes(anterior) }} (para quem está sem)
          </b-button>
          <span v-if="alterado" class="text-warning small">
            <i class="fas fa-exclamation-circle"></i> Alterações não salvas
          </span>
        </div>

        <table class="table table-sm table-bordered metas">
          <thead class="thead-dark">
            <tr>
              <th class="text-center">Região</th>
              <th>Analista</th>
              <th>Faixas de {{ nomeMes(anterior) }}</th>
              <th>Faixas de {{ nomeMes(competencia) }}</th>
              <th class="text-center">Última alteração</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="a in analistas" :key="a.user_id" :class="{ 'text-muted': !a.ativo }">
              <td class="text-center">{{ a.regiao }}</td>
              <td>
                {{ a.nome }}
                <b-badge v-if="!a.ativo" variant="secondary" class="ml-1">inativo</b-badge>
                <div class="small text-muted">{{ a.email }}</div>
              </td>
              <td class="small">
                <div v-for="f in a.faixas_anteriores" :key="f.faixa">
                  {{ formataPct(f.meta) }} <span class="text-muted">→</span> {{ formataReal(f.premio) }}
                </div>
                <span v-if="!a.faixas_anteriores.length" class="text-muted">-</span>
              </td>
              <td>
                <div v-for="(f, i) in a.faixas" :key="i" class="d-flex align-items-center mb-1">
                  <span class="small text-muted mr-2 faixa-n">{{ i + 1 }}ª</span>
                  <b-input-group size="sm" append="%" class="mr-2 meta-input">
                    <b-form-input
                      v-model="f.meta"
                      type="number"
                      min="0"
                      max="100"
                      step="0.1"
                      :disabled="salvando"
                      placeholder="meta"
                      @input="alterado = true"
                    ></b-form-input>
                  </b-input-group>
                  <b-input-group size="sm" prepend="R$" class="mr-2 premio-input">
                    <b-form-input
                      v-model="f.premio"
                      type="number"
                      min="0"
                      step="0.01"
                      :disabled="salvando"
                      placeholder="prêmio"
                      @input="alterado = true"
                    ></b-form-input>
                  </b-input-group>
                  <b-button
                    size="sm"
                    variant="link"
                    class="text-danger p-0"
                    title="Remover faixa"
                    :disabled="salvando"
                    @click="removerFaixa(a, i)"
                  >
                    <i class="fas fa-times"></i>
                  </b-button>
                </div>
                <b-button size="sm" variant="link" class="p-0" :disabled="salvando" @click="adicionarFaixa(a)">
                  <i class="fas fa-plus"></i> faixa
                </b-button>
              </td>
              <td class="text-center small">{{ a.alterado_em || '' }}</td>
            </tr>
          </tbody>
        </table>

        <div class="text-right">
          <b-button variant="primary" :disabled="salvando || !alterado" @click="salvar()">
            <b-spinner v-if="salvando" small></b-spinner>
            <i v-else class="fas fa-save"></i>
            Salvar metas de {{ nomeMes(competencia) }}
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

const paraTela = f => ({
  meta: f.meta !== null && f.meta !== undefined ? String(f.meta) : '',
  premio: f.premio !== null && f.premio !== undefined ? String(f.premio) : '',
});

export default {
  data() {
    return {
      loading: false,
      salvando: false,
      alterado: false,
      competencia: null,
      anterior: null,
      analistas: [],
    };
  },
  computed: {
    temAnterior() {
      return this.analistas.some(a => a.faixas_anteriores.length);
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    carregar() {
      const vm = this;
      if (vm.alterado && !window.confirm('Há metas não salvas. Trocar de mês mesmo assim?')) {
        return;
      }
      vm.loading = true;
      axios
        .get('/adm/retencao/metas/dados', { params: { competencia: vm.competencia } })
        .then(response => {
          const d = response.data;
          vm.competencia = d.competencia;
          vm.anterior = d.anterior;
          vm.analistas = d.analistas.map(a => ({ ...a, faixas: a.faixas.map(paraTela) }));
          vm.alterado = false;
        })
        .catch(error => {
          vm.$swal('Erro', vm.mensagemErro(error, 'Falha ao carregar as metas'), 'error');
        })
        .finally(() => {
          vm.loading = false;
        });
    },
    adicionarFaixa(a) {
      a.faixas.push({ meta: '', premio: '' });
      this.alterado = true;
    },
    removerFaixa(a, i) {
      a.faixas.splice(i, 1);
      this.alterado = true;
    },
    copiarAnterior() {
      this.analistas.forEach(a => {
        if (!a.faixas.length && a.faixas_anteriores.length) {
          a.faixas = a.faixas_anteriores.map(paraTela);
          this.alterado = true;
        }
      });
    },
    salvar() {
      const vm = this;
      for (const a of vm.analistas) {
        for (const f of a.faixas) {
          if (f.meta === '' || Number(f.meta) < 0 || Number(f.meta) > 100) {
            vm.$swal('Atenção', `${a.nome}: toda faixa precisa de meta entre 0 e 100%.`, 'warning');
            return;
          }
          if (f.premio !== '' && Number(f.premio) < 0) {
            vm.$swal('Atenção', `${a.nome}: prêmio não pode ser negativo.`, 'warning');
            return;
          }
        }
      }
      vm.salvando = true;
      axios
        .post('/adm/retencao/metas', {
          competencia: vm.competencia,
          metas: vm.analistas.map(a => ({
            user_id: a.user_id,
            faixas: a.faixas.map(f => ({ meta: Number(f.meta), premio: f.premio === '' ? null : Number(f.premio) })),
          })),
        })
        .then(response => {
          vm.alterado = false;
          vm.$swal('Pronto', response.data.mensagem, 'success');
          vm.carregar();
        })
        .catch(error => {
          vm.$swal('Erro', vm.mensagemErro(error, 'Falha ao salvar as metas'), 'error');
        })
        .finally(() => {
          vm.salvando = false;
        });
    },
    nomeMes(c) {
      if (!c) return '';
      const [ano, mes] = c.split('-');
      return MESES[Number(mes) - 1] + '/' + ano;
    },
    formataPct(v) {
      return (Number(v) || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 }) + '%';
    },
    formataReal(v) {
      return v === null || v === undefined
        ? 'sem prêmio'
        : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    mensagemErro(error, padrao) {
      const d = error.response && error.response.data;
      return (d && (d.erro || d.message)) || padrao;
    },
  },
};
</script>

<style scoped>
.metas {
  font-size: 13px;
}
.metas td {
  vertical-align: middle;
}
.meta-input {
  width: 120px;
}
.premio-input {
  width: 150px;
}
.faixa-n {
  width: 22px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_retencao/Metas.vue